'use client';
import { getNumAndUnit } from '@/components/img-box';
import { animated } from '@react-spring/web';
import { DotPage, SpanCounter } from '@ssv-website/web-ui';
import { useSpringCarousel } from '@ssv-website/hooks';
import { Image } from '@ssv-website/web-ui';
//import config from '../preset-config/carousel';
import { LegacyRef } from 'react';
import useTouchMove from '@/hooks/useTouchMove';
const carousel_config = {
  value: 0,
  duration: 4000,
  total: 4,
  // disabled: true,
};
const Carousel = ({
  data,
  config,
}: {
  data: HomePageTypes.Banner[];
  config: any;
}) => {
  const {
    transitions,
    inViewRef,
    active: carouselAct,
  } = useSpringCarousel(carousel_config);
  const list = [
    <Item list={config.item_a} mode="211" key={1} />,
    <Item list={config.item_b} mode="112" key={2} />,
    <Item list={config.item_c} mode="211" key={3} />,
    <Item list={config.item_d} mode="112" key={4} />,
  ];

  const onLink = (link: string) => {
    window.open(link);
  };
  const { ref, active } = useTouchMove();
  return (
    <>
      <div className="bg-[url(../assets/mobile/carousel_bg.png)] bg-current bg-cover pt-11 relative">
        <div
          ref={inViewRef as LegacyRef<HTMLDivElement>}
          className="relative overflow-hidden h-[19.75rem] flex mt-20"
        >
          {transitions(({ opacity, transform }, i) => (
            <animated.div
              className="w-screen h-full overflow-hidden absolute left-0 top-0"
              key={i}
              style={{ opacity, transform }}
            >
              <div className=" h-full text-center box-border px-5 pb-5">
                {list[i]}
              </div>
            </animated.div>
          ))}
        </div>
        <div
          className="absolute left-0 w-1/4 bottom-0 h-1 bg-white transition-all"
          style={{
            width: `${(carouselAct + 1) * 25}%`,
            transitionDuration: carouselAct === 0 ? '0s' : '1.5s',
          }}
        />
      </div>

      <div
        className="mt-6 flex hide-scrollbar overflow-x-auto w-full gap-3"
        ref={ref}
      >
        {data.map((item, index) => (
          <div
            key={index}
            className="w-full overflow-hidden flex-shrink-0 px-3 max-h-[228px]"
            onClick={() => onLink(item.link)}
          >
            <div className="rounded-md overflow-hidden h-full">
              <Image
                src={item.image}
                alt=""
                className="w-full object-cover"
                width={414}
                height={300}
              />
            </div>
          </div>
        ))}
      </div>
      {data?.length <= 1 ? null : (
        <div className="py-5">
          <DotPage total={data?.length} current={active} />
        </div>
      )}
    </>
  );
};

export default Carousel;

interface ItemProps {
  list: {
    src: string;
    title: string;
    text: string;
    count: string;
    count_sec?: string;
    text_sec?: string;
    link?: string;
  }[];
  mode: '111' | '211' | '112';
}
const Item = ({ list = [], mode = '211' }: ItemProps) => {
  const modeArr = mode.split('');
  const colArr = ['col-span-0', 'col-span-1', 'col-span-2'];
  return (
    <div className="grid grid-cols-2 gap-2 h-full">
      {list.map((v, i) => (
        <ImgBox key={i} {...v} className={colArr[+modeArr[i]]} />
      ))}
    </div>
  );
};

type IImgBoxProps = ItemProps['list'][number] & {
  className?: string;
};
const ImgBox = (props: IImgBoxProps) => {
  const { src, className, link, title, text, count, count_sec, text_sec } =
    props;
  const { num, unit } = getNumAndUnit(count);
  const processedText = text?.replace(/\n/g, '<br/>');

  const { num: num_sec, unit: unit_sec } = getNumAndUnit(count_sec ?? '');
  const processedText_sec = text_sec?.replace(/\n/g, '<br/>') ?? '';
  const onLink = () => {
    if (!link) return;
    window.location.href = link ?? '';
  };

  return (
    <div
      className={`flex-1 overflow-hidden rounded-md relative ${className}`}
      onClick={onLink}
    >
      <Image
        className="object-cover absolute left-0 top-0 -z-10 h-full w-full"
        src={src}
        alt=""
        fill
        quality={100}
      />
      <div className="text-white flex h-full flex-col justify-end items-start p-2 absolute top-0 left-0">
        <div className="text-xss font-600">{title}</div>
        <Count num={num} unit={unit} />
        <Text text={processedText} />
        {count_sec && <Count num={num_sec} unit={unit_sec} />}
        {text_sec && <Text text={processedText_sec} />}
      </div>
    </div>
  );
};

const Count = ({ num, unit }: { num: number; unit: string }) => (
  <div className="my-[0.125rem] h-[1.68rem]">
    <SpanCounter className="text-2xl font-300 leading-6 h-full" value={num} />
    <span className="text-2xl font-300 leading-6 h-full">{unit}</span>
  </div>
);
const Text = ({ text }: { text: string }) => (
  <div
    className="text-xss font-300 text-left leading-4"
    dangerouslySetInnerHTML={{ __html: text }}
  />
);
